export default "__VITE_ASSET__BKwv7qxz__"